/**
 * Azure AD Authentication Configuration
 * MSAL (Microsoft Authentication Library) configuration for Azure AD
 */

import { Configuration, PopupRequest } from "@azure/msal-browser";

/**
 * Configuration object for MSAL instance
 * Uses environment variables for tenant and client configuration
 */
// Get redirect URI with localhost fallback only in development
const getRedirectUri = (): string => {
  if (process.env.REACT_APP_REDIRECT_URI) {
    return process.env.REACT_APP_REDIRECT_URI;
  }
  // Only use localhost in development - use current window origin for flexibility
  if (process.env.NODE_ENV === 'development') {
    // Use window.location.origin to automatically match whatever port the app is running on
    return window.location.origin;
  }
  throw new Error('REACT_APP_REDIRECT_URI is required in production builds');
};

export const msalConfig: Configuration = {
  auth: {
    clientId: process.env.REACT_APP_AZURE_CLIENT_ID || "c6a6395c-6a39-4fa0-b5b6-1f61e1daa1d0",
    authority: `https://login.microsoftonline.com/${process.env.REACT_APP_AZURE_TENANT_ID || "06a7113a-1417-4d95-b6f7-11596ef7b242"}`,
    redirectUri: getRedirectUri(),
    postLogoutRedirectUri: getRedirectUri(),
    navigateToLoginRequestUrl: false, // Prevent redirect loops
  },
  cache: {
    cacheLocation: "localStorage", // Store tokens in localStorage for persistence
    storeAuthStateInCookie: true, // Critical for Safari and mobile browsers - stores auth state in cookies as fallback
    secureCookies: window.location.protocol === "https:", // Use secure cookies in production
  },
};

/**
 * Scopes requested for login
 * These scopes define what permissions the app is requesting from the user
 */
export const loginRequest: PopupRequest = {
  scopes: ["User.Read"], // Basic profile information
};

/**
 * Scopes requested for API access
 * For local development, we use User.Read since the backend uses DevBypass
 * In production, request the access_as_user scope for CaseTrac API
 */
export const apiRequest = {
  scopes: [`api://${process.env.REACT_APP_AZURE_CLIENT_ID || "c6a6395c-6a39-4fa0-b5b6-1f61e1daa1d0"}/access_as_user`],
};
